"use strict";
//import { Tooltip, Toast, Popover } from 'bootstrap';
import * as bootstrap from "bootstrap";

import "osoigonextsrc/scss/main.scss";
import "websrc/scss/main-override.scss";

const OsoigoNext = {
  config: {
    loginLinkSelector: ".login-link",
    loginSelector: "#login-popup-wrapper",
    loginCloseSelector: ".close",
  },

  getCookie: function (name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== "") {
      const cookies = document.cookie.split(";");
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        // Does this cookie string begin with the name we want?
        if (cookie.substring(0, name.length + 1) === name + "=") {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  },

  setCookie: function (name, value, expiration_days) {
    var d = new Date();
    d.setTime(d.getTime() + expiration_days * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  },

  setCSRFtoken: function () {
    const csrftoken = OsoigoNext.getCookie("csrftoken");

    var forms = document.querySelectorAll('form[method="post"]');
    forms.forEach(function (elem) {
      var csrf = document.createElement("input");
      csrf.setAttribute("type", "hidden");
      csrf.setAttribute("name", "csrfmiddlewaretoken");
      csrf.setAttribute("value", csrftoken);
      elem.appendChild(csrf);
    });
  },

  colapseAlert: function () {
    let coll = document.getElementsByClassName("collapsible");
    let i;

    for (i = 0; i < coll.length; i++) {
      coll[i].addEventListener("click", function () {
        this.classList.toggle("active");
        const content = this.nextElementSibling;
        if (content.style.maxHeight) {
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = content.scrollHeight + "px";
        }
      });
    }
  },

  toggleComplaints: function () {
    // Complaints
    const complaintsOpenBtns = document.querySelectorAll(
      ".complaints-expand-btn"
    );
    const complaintsCancelBtns = document.querySelectorAll(
      ".complaints-cancel-btn"
    );
    const complaintsForms = document.querySelectorAll(".complaints-form");

    complaintsOpenBtns.forEach((btn, index) => {
      btn.addEventListener("click", (event) => {
        event.preventDefault();
        const form = complaintsForms[index];
        const button = complaintsOpenBtns[index];
        form.style.display = form.style.display === "none" ? "block" : "none";
      });
    });

    complaintsCancelBtns.forEach((btn, index) => {
      btn.addEventListener("click", (event) => {
        event.preventDefault();
        const form = complaintsForms[index];
        form.style.display = "none";
      });
    });
  },

  background_gallery: function (container, images, delay) {
    var image = images.shift();
    images.push(image);
    container.setAttribute("style", 'background-image: url("' + image + '")');
    window.setTimeout(
      OsoigoNext.background_gallery,
      delay,
      container,
      images,
      delay
    );
  },

  /* Show/Hide a target element on clicking on provided links.
   * When the element must be shown it will have the 'popup-visible' class.
   * When thee element must be hiddent this class will be removed.
   *
   * Params:
   *   * links: a list of dom elements where click event will be attached.
   *   * container: dom element that will show/hide.
   *   * close_buttons: list of dom elements that will hide the element.
   */
  popup: function (links, container, close_buttons) {
    for (var link of links) {
      link.addEventListener("click", function (event) {
        event.preventDefault();
        // add backdrop bootsrap
        const backdrop = document.createElement("div");
        backdrop.classList.add("fade", "modal-backdrop", "show");
        container.parentNode.insertBefore(backdrop, container);
        // add class visible
        container.classList.add("popup-visible");
      });
    }
    for (var close_button of close_buttons) {
      close_button.addEventListener("click", function (event) {
        event.preventDefault();
        // remove backdrop bootsrap
        const backdrop = document.querySelector(".fade.modal-backdrop.show");
        if (backdrop) backdrop.remove();
        // clean class visible
        container.classList.remove("popup-visible");
      });
    }
  },

  /* Disable the button after form submit.
   *
   * Params:
   *   * form: dom element
   *   * button: dom element
   */
  disableAfterSubmit: function (form, button) {
    form.addEventListener("submit", () => {
      button.disabled = true;
    });
  },

  bind_generics: function () {
    let actions = document.querySelectorAll("[data-action]");
    for (let action of actions) {
      switch (action.dataset.action) {
        case "toggle":
          let target = document.querySelector(action.dataset.target);
          let options = {
            source: action,
            target: target,
            targetGroup: action.dataset.group,
            sourceGroup: action.dataset.sourcegroup,
          };
          const sourceCssClass = action.dataset.sourcecssclass;
          const targetCssClass = action.dataset.targetcssclass;
          if (typeof sourceCssClass != "undefined")
            options.sourceCssClass = sourceCssClass;
          if (typeof targetCssClass != "undefined")
            options.targetCssClass = targetCssClass;
          OsoigoNext.toggle(options);
          break;
        case "popup":
          let popup = document.querySelector(action.dataset.target),
            popup_close = popup.querySelectorAll(action.dataset.close);
          OsoigoNext.popup([action], popup, popup_close);
          break;
        case "disableAfterSubmit":
          let form = document.querySelector(action.dataset.form);
          OsoigoNext.disableAfterSubmit(form, action);
          break;
      }
    }
    let inputmask_actions = document.querySelectorAll("[data-inputmask]");
    Inputmask().mask(inputmask_actions);
  },

  /* Show/hide an element onclicking on provided source element.
   * Several target elements can share a class, so only one of the
   * targets can be show. Showing a target hides all other targets.
   *
   * Params:
   * * source: dom element where the click event will be attached
   * * target: dom element that will shon/hide.
   * * cssClass: string with the class that will be added to showed
   *   elements and removed from hidden ones.
   * * group: class name of the group shared by targets
   */
  toggle: function (options) {
    const default_options = {
      source: undefined,
      target: undefined,
      targetCssClass: "visible",
      sourceCssClass: "active",
      targetGroup: undefined,
      sourceGroup: undefined,
    };

    options = { ...default_options, ...options };

    let targets = [];
    let sources = [];
    if (options.targetGroup) {
      targets = document.querySelectorAll("." + options.targetGroup);
    }
    if (options.sourceGroup) {
      sources = document.querySelectorAll("." + options.sourceGroup);
    }
    options.source.addEventListener("click", function () {
      if (options.target.classList.contains(options.targetCssClass)) {
        options.target.classList.remove(options.targetCssClass);
        options.source.classList.remove(options.sourceCssClass);
      } else {
        options.target.classList.add(options.targetCssClass);
        options.source.classList.add(options.sourceCssClass);
        for (let target of targets) {
          if (target != options.target) {
            target.classList.remove(options.targetCssClass);
          }
        }
        for (let source of sources) {
          if (source != options.source) {
            source.classList.remove(options.sourceCssClass);
          }
        }
      }
    });
  },

  getParent: function (item, selector) {
    for (; item && item !== document; item = item.parentNode) {
      if (item.matches(selector)) return item;
    }
    return null;
  },

  subscripcion_mark_all_as_read: function (url) {
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          window.location.reload();
        }
      });
  },

  subscripcion_mark_as_read: function (url, id) {
    const csrftoken = OsoigoNext.getCookie("csrftoken");
    let data = new FormData();
    data.set("notification_id", id);
    data.set("csrfmiddlewaretoken", csrftoken);
    fetch(url, { method: "POST", body: data })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          const count = parseInt(
            document.getElementById("id_notification_badge").innerHTML
          );
          if (count - 1 === 0) {
            window.location.reload();
          } else {
            document.getElementById("id_notification_badge").innerHTML =
              count - 1;
            //document.getElementById("id_notification_badge_mobile").innerHTML =
              count - 1;
            document.getElementById(
              "id_notification_" + id.toString()
            ).hidden = true;
          }
        }
      });
  },

  showUploadedFilename: function () {
    const inputs = document.querySelector('input[type="file"]');
    if (inputs != null) {
      inputs.addEventListener("change", (event) => {
        event.target.classList.add("active");
        let archivo = event.target.value;
        let arr = archivo.split("\\");
        let uploadname = document.querySelector(".upload-name");
        if (uploadname != null) {
          uploadname.remove();
        }
        let file_name = document.createElement("div");
        file_name.className = "upload-name";
        file_name.innerHTML = arr[arr.length - 1];
        event.target.parentNode.insertBefore(
          file_name,
          event.target.nextSibling
        );
      });
    }
  },

  // https://youmightnotneedjquery.com/#ready
  ready: function (fn) {
    if (document.readyState !== "loading") {
      fn();
    } else {
      document.addEventListener("DOMContentLoaded", fn);
    }
  },

  init: function () {
    OsoigoNext.setCSRFtoken();
    OsoigoNext.colapseAlert();
    OsoigoNext.toggleComplaints();
    OsoigoNext.showUploadedFilename();

    const config = OsoigoNext.config,
      loginLink = document.querySelectorAll(config.loginLinkSelector),
      login = document.querySelector(config.loginSelector);

    if (loginLink && login) {
      const loginClose = login.querySelectorAll(config.loginCloseSelector);
      OsoigoNext.popup(loginLink, login, loginClose);
    }

    OsoigoNext.bind_generics();
  },
};

const AjaxForm = {
  config: {
    backButtonSelector: ".js-close",
  },

  Form: function (links, url, config) {
    const self = this;
    this.url = url;
    this.config = { ...AjaxForm.config, ...config };
    this.container = document.createElement("div");

    this.container.classList.add("ajax-form-container");
    this.sended = false;
    document.getElementsByTagName("body")[0].appendChild(this.container);

    for (var link of links) {
      link.addEventListener("click", function (event) {
        event.preventDefault();
        self.open();
      });
    }
  },
};

AjaxForm.Form.prototype = {
  open: function () {
    const self = this;
    this.fetchRetry(this.url)
      .catch((e) => alert(`${e.name}: ${e.message}`))
      .then((response) => {
        if (!response.ok)
          alert("Código de respuesta incorrecto: " + response.status);
        return response.json();
      })
      .catch((e) => alert("Error en respuesta JSON"))
      .then((data) => {
        self.bind(data.content);
        //hide body scroll
        document.body.classList.add("modal-open");
        document.body.style.overflow = "hidden";
        document.body.style.paddingRight = "15px";
      });
  },

  close: function () {
    this.container.innerHTML = "";
    //delete hide body scroll
    document.body.classList.remove("modal-open");
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
  },

  bind: function (content) {
    const self = this;
    self.sended = false;
    this.container.innerHTML = "";
    const newContent = document
      .createRange()
      .createContextualFragment(content.trim());
    // add backdrop bootstrap
    const backdrop = document.createElement("div");
    backdrop.classList.add("fade", "modal-backdrop", "show");
    this.container.appendChild(backdrop);
    // add Content
    this.container.append(newContent);
    const backButtons = this.container.querySelectorAll(
      this.config.backButtonSelector
    );
    for (let backButton of backButtons) {
      backButton.addEventListener("click", function (event) {
        event.preventDefault();
        self.close();
      });
    }

    const form = this.container.querySelector("form");
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      self.send(form);
    });
  },

  send: function (form) {
    const self = this;
    if (self.sended) return;
    self.sended = true;
    const formData = new FormData(form);
    fetch(self.url, { method: "POST", body: formData })
      .then((response) => response.json())
      .then((data) => {
        if (data.target) {
          window.location = data.target;
        } else {
          self.bind(data.content);
        }
      });
  },

  fetchRetry: function (url) {
    return new Promise((resolve, reject) => {
      let attempts = 1;
      function fetch_retry(url, n) {
        return fetch(url)
          .then(resolve)
          .catch(function (error) {
            if (n <= 1) reject(error);
            else {
              setTimeout(() => {
                attempts++;
                fetch_retry(url, n - 1);
              }, attempts * 3000);
            }
          });
      }
      return fetch_retry(url, 5);
    });
  },
};

const Push = {
  config: {},

  urlBase64ToUint8Array: function (base64String) {
    var padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    var base64 = (base64String + padding)
      .replace(/\-/g, "+")
      .replace(/_/g, "/");

    var rawData = window.atob(base64);
    var outputArray = new Uint8Array(rawData.length);

    for (var i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  },

  loadVersionBrowser: function () {
    if ("userAgentData" in navigator) {
      // navigator.userAgentData is not available in
      // Firefox and Safari
      const uaData = navigator.userAgentData;
      // Outputs of navigator.userAgentData.brands[n].brand are e.g.
      // Chrome: 'Google Chrome'
      // Edge: 'Microsoft Edge'
      // Opera: 'Opera'
      let browsername;
      let browserversion;
      let chromeVersion = null;
      for (var i = 0; i < uaData.brands.length; i++) {
        let brand = uaData.brands[i].brand;
        browserversion = uaData.brands[i].version;
        if (
          brand.match(/opera|chrome|edge|safari|firefox|msie|trident/i) !== null
        ) {
          // If we have a chrome match, save the match, but try to find another match
          // E.g. Edge can also produce a false Chrome match.
          if (brand.match(/chrome/i) !== null) {
            chromeVersion = browserversion;
          }
          // If this is not a chrome match return immediately
          else {
            browsername = brand.substr(brand.indexOf(" ") + 1);
            return {
              name: browsername,
              version: browserversion,
            };
          }
        }
      }
      // No non-Chrome match was found. If we have a chrome match, return it.
      if (chromeVersion !== null) {
        return {
          name: "chrome",
          version: chromeVersion,
        };
      }
    }
    // If no userAgentData is not present, or if no match via userAgentData was found,
    // try to extract the browser name and version from userAgent
    const userAgent = navigator.userAgent;
    var ua = userAgent,
      tem,
      M =
        ua.match(
          /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
        ) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return { name: "IE", version: tem[1] || "" };
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\bOPR\/(\d+)/);
      if (tem != null) {
        return { name: "Opera", version: tem[1] };
      }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
      M.splice(1, 1, tem[1]);
    }
    return {
      name: M[0],
      version: M[1],
    };
  },

  registerDevice: function (browser, subscription) {
    var endpointParts = subscription.endpoint.split("/");
    var registration_id = endpointParts[endpointParts.length - 1];
    /*
        var data = {
            'browser': browser.name.toUpperCase(),
            'p256dh': btoa(String.fromCharCode.apply(null, new Uint8Array(subscription.getKey('p256dh')))),
            'auth': btoa(String.fromCharCode.apply(null, new Uint8Array(subscription.getKey('auth')))),
            'name': 'XXXXX',
            'registration_id': registration_id
        };
        */
    var data = {
      name: browser.name.toUpperCase(),
      registration_id: registration_id,
      active: true,
      cloud_message_type: "FCM",
    };
    fetch(Push.config.gcmEndpoint, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "X-CSRFToken": OsoigoNext.getCookie("csrftoken"),
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
  },

  init: function (options) {
    Push.config = options;
    if ("serviceWorker" in navigator) {
      // The service worker has to store in the root of the app
      // http://stackoverflow.com/questions/29874068/navigator-serviceworker-is-never-ready
      var browser = Push.loadVersionBrowser();
      navigator.serviceWorker
        .register("/serviceworker.js", {
          scope: options.scope,
        })
        .then(function (registration) {
          // Registration was successful
          if (options.debug)
            console.log(
              "ServiceWorker registration successful with scope: ",
              registration.scope
            );

          registration.pushManager
            .subscribe({
              userVisibleOnly: true,
              applicationServerKey: Push.urlBase64ToUint8Array(
                options.applicationServerKey
              ),
            })
            .then(function (sub) {
              Push.registerDevice(browser, sub);
            });
        })
        .catch((err) => {
          // registration failed :(
          if (options.debug)
            console.log("ServiceWorker registration failed: ", err);
        });
    }
  },
};

const BootstrapNext = {
    // crea o reutiliza el contenedor de toasts
    _getOrCreateToastContainer() {
      let c = document.getElementById("toastContainer")
        || document.querySelector(".toast-container");
      if (!c) {
        c = document.createElement("div");
        c.id = "toastContainer";
        c.className = "toast-container position-fixed bottom-0 end-0 p-3";
        c.style.zIndex = "3080";
        document.body.appendChild(c);
      }
      return c;
    },
  
    // escape básico para evitar inyección si el mensaje viene de entradas de usuario
    _escapeHtml(str) {
      return String(str)
        .replaceAll("&", "&amp;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;")
        .replaceAll('"', "&quot;")
        .replaceAll("'", "&#39;");
    },
  
    /**
     * Muestra un toast de Bootstrap
     * @param {string} message - texto del toast
     * @param {'success'|'info'|'warning'|'danger'|'error'|'secondary'} type - tipo visual
     * @param {number} delay - milisegundos antes de autohide (default 3000)
     */
    showToast(message, type = "success", delay = 3000) {
      const container = this._getOrCreateToastContainer();
  
      // mapear 'error' -> 'danger' para coincidir con Bootstrap
      const bsType = (type === "error") ? "danger" : type;
  
      const toastEl = document.createElement("div");
      toastEl.className = `toast align-items-center text-bg-${bsType} border-0 rounded-1`;
      toastEl.setAttribute("role", "alert");
      toastEl.setAttribute("aria-live", "assertive");
      toastEl.setAttribute("aria-atomic", "true");
  
      toastEl.innerHTML = `
        <div class="d-flex">
          <div class="toast-body">${this._escapeHtml(message)}</div>
          <button type="button" class="btn-close btn-close-white me-2 m-auto"
                  data-bs-dismiss="toast" aria-label="Close"></button>
        </div>
      `;
  
      container.appendChild(toastEl);
  
      const t = new window.bootstrap.Toast(toastEl, { autohide: true, delay });
      t.show();
  
      toastEl.addEventListener("hidden.bs.toast", () => toastEl.remove());
    },
  };
  
// Exponelos globalmente de manera manual ya que vite los compila como modulos, y no tienen scope global.
window.OsoigoNext = OsoigoNext;
window.Push = Push;
window.AjaxForm = AjaxForm;
//window.bootstrap = { Tooltip, Toast, Popover };
window.bootstrap = bootstrap;
window.BootstrapNext = BootstrapNext

document.addEventListener("DOMContentLoaded", OsoigoNext.init, { once: true });
